export const USER_REGISTERED = 'Packaging Toolbox Sign Up Form Submitted'
export const ACCOUNT_CONFIRMED = 'Packaging Toolbox Account Confirmed'
export const DIELINE_GENERATED = 'Packaging Toolbox Dieline Generated'
export const DIELINE_DOWNLOADED = 'Packaging Toolbox Dieline Downloaded'
export const DIECUT_LAYOUT_GENERATED =
  'Packaging Toolbox Diecut Layout Generated'
export const DIECUT_LAYOUT_DOWNLOADED =
  'Packaging Toolbox Diecut Layout Downloaded'
